module.exports = __webpack_public_path__ + "static/media/10.2240ba9a.png";